import { Injectable } from '@angular/core';

import { AuthService } from 'app/services/auth.service';
import { FuseNavigationService } from '@fuse/components/navigation/navigation.service';

import { UserModel } from 'app/models/user.model';
import { FuseNavigation } from '@fuse/types';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { UserManager } from 'oidc-client';
import { ConfigsLoaderService } from './config-loader.service';
import { Observable } from 'rxjs/internal/Observable';
import { ContentType } from 'app/enums/content-type.enum';
import {of} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class MainPageService {
    private apiEndPoint: string;

    constructor(
        private http: HttpClient,
        private translate: TranslateService,
        private router: Router,
        private config: ConfigsLoaderService,
    ) {
        this.apiEndPoint = this.config.apiUrl;
    }

    mockData: PageContent[] = [
        {
            "header": "Travel",
            "title": "Big City Life",
            "tenantId": 1,
            "contentTypeId": 1,
            "body": "Cards provide context and an entry point to more robust information and views, and their content and quantity can vary greatly.",
            "thumbnailFileId": 1,
            "thumbnailFile": {
                "id": 1,
                "name": "file1",
                "fileLength": 1,
                "mimeType": "image/jpeg",
                "url": "https://i.imgur.com/eECefMJ.jpg"
            },
            "mediaFileId": 1,
            "mediaFile": {
                "id": 1,
                "name": "file1",
                "fileLength": 1,
                "mimeType": "image/png",
                "url": "https://AZURESTORAGE/ASDASDEEQA"
            },
            "orderPosition": 1,
            "active": true
        },
        {
            "header": "Travel2",
            "title": "Big City Life 2",
            "tenantId": 1,
            "contentTypeId": 1,
            "body": "Cards provide context and an entry point to more robust information and views, and their content and quantity can vary greatly.",
            "thumbnailFileId": 2,
            "thumbnailFile": {
                "id": 2,
                "name": "video1",
                "fileLength": 1,
                "mimeType": "video/mp4",
                "url": ""
            },
            "mediaFileId": 1,
            "mediaFile": {
                "id": 1,
                "name": "file1",
                "fileLength": 1,
                "mimeType": "video/webm",
                "url": "https://interactive-examples.mdn.mozilla.net/media/cc0-videos/flower.webm"
            },
            "orderPosition": 2,
            "active": true
        },
        {
            "header": "Travel3",
            "title": "Big City Life 3",
            "tenantId": 1,
            "contentTypeId": 2,
            "body": "Cards provide context and an entry point to more robust information and views, and their content and quantity can vary greatly.",
            "thumbnailFileId": 3,
            "thumbnailFile": {
                "id": 3,
                "name": "video1",
                "fileLength": 1,
                "mimeType": "image/jpg",
                "url": "assets/images/cards/card1.jpg"
            },
            "mediaFileId": 5,
            "mediaFile": {
                "id": 5,
                "name": "file4",
                "fileLength": 1,
                "mimeType": "video/webm",
                "url": "https://interactive-examples.mdn.mozilla.net/media/cc0-videos/flower.webm"
            },
            "orderPosition": 2,
            "active": true
        },
        {
            "header": "Travel4",
            "title": "Big City Life 4",
            "tenantId": 1,
            "contentTypeId": 2,
            "body": "Cards provide context and an entry point to more robust information and views, and their content and quantity can vary greatly.",
            "thumbnailFileId": 4,
            "thumbnailFile": {
                "id": 4,
                "name": "video1",
                "fileLength": 1,
                "mimeType": "image/jpg",
                "url": "assets/images/cards/card3.jpg"
            },
            "mediaFileId": 6,
            "mediaFile": {
                "id": 6,
                "name": "file6",
                "fileLength": 1,
                "mimeType": "application/pdf",
                "url": "https://api.gokeepup.com/rpt/msjUZmCIicmCKZz3ahPW/VHppuzYhLJCkjFgwn3WU/s51NWUU34WgqxA9Qw3wD"
            },
            "orderPosition": 2,
            "active": true
        }
    ]

    getContentsLanding(): Observable<PageContent[]> { //
        return this.http.get<PageContent[]>(`${this.apiEndPoint}/DataSource/GetContents/` + ContentType.Landing);
        // return of(this.mockData);
    }

    getContentHome(): Observable<PageContent[]> { //
        return this.http.get<PageContent[]>(`${this.apiEndPoint}/DataSource/GetContents/` + ContentType.Home);
        // return of(this.mockData);
    }

    getResourcesContent(): Observable<PageContent[]> { // 
        return this.http.get<PageContent[]>(`${this.apiEndPoint}/DataSource/GetContents/` + ContentType.Resources);
        // return this.mockData;
    }
    getFAQs(): Observable<FAQs> { 
        return this.http.get<FAQs>(`${this.apiEndPoint}/DataSource/GetFAQs`);
    }
}

export interface PageContent{
    header: string;
    title: string;
    tenantId: number;
    contentTypeId: ContentType;
    body: string;
    thumbnailFileId: number;
    thumbnailFile: ContentFiles;
    mediaFileId: number;
    mediaFile: ContentFiles
    orderPosition: number;
    active: boolean;
}

interface ContentFiles{
    id: number;
    name: string;
    fileLength: number;
    mimeType: string;
    url: string
}

export interface FAQs{
    id: number;
    question: string;
    answer: string;
    orderPosition: number;
    active: boolean;
}
